var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("tab", [
    _c(
      "div",
      { staticClass: "borrow" },
      [
        _c("div", { staticClass: "borrow-tab" }, [
          _c(
            "button",
            {
              staticClass: "button",
              class: {
                "button-active button-active-left":
                  _vm.tab === "applicationLoan",
              },
              on: { click: _vm.changeToApplication },
            },
            [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$t("FAQAPPLICATIONLOANS")) +
                  "\n            "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "button",
              class: {
                "button-active button-active-right":
                  _vm.tab !== "applicationLoan",
              },
              on: { click: _vm.changeToPayment },
            },
            [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$t("FAQPAYMENTREPAYMENT")) +
                  "\n            "
              ),
            ]
          ),
        ]),
        _vm._v(" "),
        _vm.tab === "applicationLoan"
          ? _c("yqg-md-preview", {
              attrs: {
                "md-text": _vm.$t("mdText", [
                  _vm.yqdContact.email,
                  _vm.finContact.email,
                ]),
              },
            })
          : _c("yqg-md-preview", {
              attrs: {
                "md-text": _vm.$t("paymentText", [
                  _vm.yqdContact.email,
                  _vm.finContact.email,
                  _vm.overdueRate,
                ]),
              },
            }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }